const cscAnswer = {
    namespaced: true,
    state: {
        isVisible: false,
        resolve: null,
        reject: null,
        fields: null,
    },
    mutations: {
        SET_IS_VISIBLE(state, payload) {
            state.isVisible = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_REJECT(state, payload) {
            state.reject = payload;
        },
        SET_FIELDS(state, payload){
            state.fields = payload;
        },
        UPDATE_FIELD_VALUE(state, payload){
            let field = state.fields.find(f => f.name == payload.property);
            if (field)
                field.field.value =  payload.value
        }
    },
    actions: {
        async open({ commit }, fields) {

            commit('SET_FIELDS', fields);
            commit('SET_IS_VISIBLE', true);
            
            return new Promise((resolve, reject) => {
                commit('SET_RESOLVE', resolve);
                commit('SET_REJECT', reject);
            });
        },
        async ok({ commit, state }) {
            commit('SET_IS_VISIBLE', false);

            let result = {}
            state.fields.forEach(f => {
                result[f.name] = f.field.value;
            });
       
            state.resolve(result);
        },
        async cancel({ commit, state }) {
            commit('SET_IS_VISIBLE', false);
            state.reject({ message: "Cancelled" });
        },
        updateField({ commit }, data) {
            commit('UPDATE_FIELD_VALUE', data);
        },
    },
    getters: {
        isVisible: (s) => s.isVisible,
        
        isValid: (s) => (s.fields.every(f => f.field.value)),
        
        fields: (s) => s.fields,
    }
}

export default cscAnswer;